import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ObligationDetailPage = lazy(() => import("@/features/dashboard/pages/obligation-detail"));

export const Route = createFileRoute("/(app)/dashboard/obligations/$taxType")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading obligation…</div>}>
      <ObligationDetailPage />
    </Suspense>
  ),
});
